<template>
  <div>
    <TopNavigation activeApp="IP Manager"/>
    <h1>Hello from protected ipmansearch!</h1>
  </div>
</template>

<script>
export default {
  name: 'ipmansearch',
}
</script>